import $ from 'jquery';

/* eslint-disable object-property-newline */
const defaults = {
  disclaimerPostPath: 'post/google-translate-disclaimer',
  disclaimerPost: 'Disclaimer',
  languagesArray: {
    en: 'English',
    af: 'Afrikaans', sq: 'Albanian', am: 'Amharic', ar: 'Arabic', hy: 'Armenian', az: 'Azerbaijani',
    eu: 'Basque', be: 'Belarusian', bn: 'Bengali', bs: 'Bosnian', bg: 'Bulgarian', ca: 'Catalan',
    ceb: 'Cebuano', ny: 'Chichewa', 'zh-CN': 'Chinese (Simplified)', 'zh-TW': 'Chinese (Traditional)',
    co: 'Corsican', hr: 'Croatian', cs: 'Czech', da: 'Danish', nl: 'Dutch', eo: 'Esperanto',
    et: 'Estonian', tl: 'Filipino', fi: 'Finnish', fr: 'French', fy: 'Frisian', gl: 'Galician',
    ka: 'Georgian', de: 'German', el: 'Greek', gu: 'Gujarati', ht: 'Haitian Creole', ha: 'Hausa',
    haw: 'Hawaiian', iw: 'Hebrew', hi: 'Hindi', hmn: 'Hmong', hu: 'Hungarian', is: 'Icelandic',
    ig: 'Igbo', id: 'Indonesian', ga: 'Irish', it: 'Italian', ja: 'Japanese', jw: 'Javanese',
    kn: 'Kannada', kk: 'Kazakh', km: 'Khmer', ko: 'Korean', ku: 'Kurdish (Kurmanji)', ky: 'Kyrgyz',
    lo: 'Lao', la: 'Latin', lv: 'Latvian', lt: 'Lithuanian', lb: 'Luxembourgish', mk: 'Macedonian',
    mg: 'Malagasy', ms: 'Malay', ml: 'Malayalam', mt: 'Maltese', mi: 'Maori', mr: 'Marathi', mn: 'Mongolian',
    my: 'Myanmar (Burmese)', ne: 'Nepali', no: 'Norwegian', ps: 'Pashto', fa: 'Persian', pl: 'Polish',
    pt: 'Portuguese', pa: 'Punjabi', ro: 'Romanian', ru: 'Russian', sm: 'Samoan', gd: 'Scots Gaelic',
    sr: 'Serbian', st: 'Sesotho', sn: 'Shona', sd: 'Sindhi', si: 'Sinhala', sk: 'Slovak', sl: 'Slovenian',
    so: 'Somali', es: 'Spanish', su: 'Sundanese', sw: 'Swahili', sv: 'Swedish', tg: 'Tajik', ta: 'Tamil',
    te: 'Telugu', th: 'Thai', tr: 'Turkish', uk: 'Ukrainian', ur: 'Urdu', uz: 'Uzbek', vi: 'Vietnamese',
    cy: 'Welsh', xh: 'Xhosa', yi: 'Yiddish', yo: 'Yoruba', zu: 'Zulu',
  },
};

export default class GoogleTranslate {
  constructor(element, options) {
    this.$element = $(element);
    this.settings = Object.assign({}, defaults, options);
    this.buildMenu();
    this.buttonBehavior();
    this.linkBehaviour();
  }

  buildMenu() {
    const menu = $('<div class="translate-menu hide"></div>');
    const optionsList = $('<ul class="translate-options"></ul>');
    let li = $('<li></li>').addClass('disclaimer-menu-item').appendTo(optionsList);
    $('<a></a>').text(this.settings.disclaimerPost).attr('href', `${window.location.protocol}//${window.location.hostname}/${this.settings.disclaimerPostPath}`).appendTo(li);
    li = $('<li></li>').addClass('disclaimer-menu-item').appendTo(optionsList);
    $('<span></span>').text('Select Language: ').appendTo(li);
    const languages = this.settings.languagesArray;
    Object.keys(languages).forEach((lang) => {
      li = $('<li></li>').addClass('language-menu-item').appendTo(optionsList);
      $('<a></a>').addClass('ui-all')
        .text(languages[lang])
        .attr('value', lang)
        .attr('href', '#')
        .appendTo(li);
    });
    $(optionsList).appendTo(menu);
    $(menu).appendTo(this.$element);
  }

  buttonBehavior() {
    const button = this.$element.find('button.translate.button');
    button.bind('click', (e) => {
      e.preventDefault();
      const menu = $('#maryland-translate div.translate-menu');
      if (menu.hasClass('hide')) {
        menu.removeClass('hide').addClass('active');
      } else {
        menu.removeClass('active').addClass('hide');
      }
    });
  }

  linkBehaviour() {
    const selectCustom = this.$element.find('.language-menu-item');
    selectCustom.each(function () {
      $(this).bind('click', (e) => {
        e.preventDefault();
        const newLanguage = $(this).find('a.ui-all').attr('value');
        if (document.cookie.includes('googtrans')) {
          const cookieValue = `/en/${newLanguage}`;
          let ckDomain;
          for (ckDomain = window.location.hostname.split('.'); ckDomain.length > 2;) {
            ckDomain.shift();
          }
          ckDomain = `;domain=${ckDomain.join('.')}`;
          // domain cookie
          document.cookie = `googtrans=${cookieValue}; expires=Thu, 07-Mar-2047 20:22:40 GMT; path=/${ckDomain}`;
          // host-only cookie (with no domain name definition)
          document.cookie = `googtrans=${cookieValue}; expires=Thu, 07-Mar-2047 20:22:40 GMT; path=/`;
        } else {
          document.cookie = `googtrans=/en/${newLanguage}`;
        }
        window
          .location
          .replace(window.location.pathname + window.location.search + window.location.hash);
      });
    });
  }
}
